import React, { useState } from 'react';
import { Card, Row, Col } from 'antd';
import UserForm from '../components/User/UserForm';
import UserList from '../components/User/UserList';
import { User } from '../types/user';
import { useTranslation } from "react-i18next";

const UsersPage: React.FC = () => {
  const [editUser, setEditUser] = useState<User | undefined>(undefined);
  const { t, i18n } = useTranslation();

  return (

    <div style={{ direction: i18n.language === 'ar' || i18n.language === 'ckb' ? 'rtl' : 'ltr', padding: '0 16px' }}>
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} sm={24} md={10} lg={8} xl={6}>
            <Card title={editUser ? t('edit_user') : t('add_new_user')}>
              <UserForm editUser={editUser} onFinishEdit={() => setEditUser(undefined)} />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={14} lg={16} xl={18}>
            <Card title={t('user_list')}>
              <UserList onEdit={setEditUser} />
            </Card>
          </Col>
        </Row>
    </div>
  );
};

export default UsersPage;